<p>{{'account.go_buy_licence_body' + role | translate}}</p>
@if (data?.isInSnackbar) {
  <button mat-raised-button (click)="dismiss()" class="mat-accent">
    {{ 'account.go_buy_licence_ok' + role | translate }}
  </button>
}
<a mat-raised-button class="mat-accent" [href]="'navigation.external-target-link-menu-url' | translate">
  {{ 'account.go_buy_licence_link' + role | translate }}
</a>
